import React from "react"

import { localizer } from "../../../Translator";

import StateIcon from '../../../images/state_noBackground.png'
import ProofIcon from '../../../images/proof_noBackground.png'
import CertIcon from '../../../images/cert_noBackground.png'
import ReportIcon from '../../../images/report_noBackground.png'
import StampIcon from '../../../images/stamp_noBackground_v4.png'

import IconButton from '@material-ui/core/IconButton';
import TableRow from '@material-ui/core/TableRow';
import { Grid } from "@material-ui/core"
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from "@material-ui/core"
import { Button } from "@material-ui/core"
import Tooltip from '@material-ui/core/Tooltip';
import { Backdrop, CircularProgress } from "@material-ui/core"
import Chip from '@material-ui/core/Chip'

import FeedbackShipmentSummary from './FeedbackShipmentSummary'

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'

import DateCustom from "../../Utilities/DateCustom"
import Roles from "../../Utilities/Roles.js"
import { SnackbarCustom } from "../../Utilities/SnackbarCustom";
import StateCodes from "../../Utilities/StateCodes.js";

import InboxCli from "../../../sdk/InboxCli";
import OutboxCli from "../../../sdk/OutboxCli"
import CycleCli from "../../../sdk/CycleCli.js"
import ProductCli from "../../../sdk/ProductCli";

export class FeedbackRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {

      // Indicates if expandible row is open or closed
      open: false,

      // Indicates feedback want to be read/unread
      checked: false,

      // Indicates if shipment summary of the feedback is open or closed
      openModal: false,
      isLoadingDraft: false,
      
      // Shipment object which feedback belong to
      shipment: {},
      shipmentFeedbacks: [],

      currentStateData: null,

      states: [],
      certs: [],
      proofs: [],
      reports: [],
      documents: [],
      stampedCopies: [],

      //// String errors to display in case of service calls go wrong
      message: null,
      severity: "error",
      
      //assigned codes
      trackingsDispatches: [],
      trackingMain: {}
    }
  }

  /**
   * Component initialization. Filling state with the shipment and its associate information (drafts, feedbacks, etc)
   */
  componentDidMount() {
    if (this.props.role === Roles.ROLE_USER.Name) {
      this.getShipmentByCode(this.props.feedback)
      return
    }

    if (this.props.role === Roles.ROLE_ADMIN.Name || this.props.role === Roles.ROLE_SUPERVISOR.Name) {
      this.getShipmentByCodeOfBillable(this.props.feedback)
      return
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isChecked === this.props.isChecked) return

    //let checked = this.props.feedbacksIdsSelected.includes(this.props.feedback.returnId)
    this.setState({ checked: this.props.isChecked })
  }

  getShipmentByCode = (feedback) => {
    OutboxCli.GetShipmentByCode(feedback.shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        this.setState({ shipment: data, message: null },
          /* () => {
            this.getFeedbacksOfShipment()
            this.getTrackingsOfShipment()
          } */
        )
      }
    })
  }

  getShipmentByCodeOfBillable = (feedback) => {
    OutboxCli.GetShipmentByCodeOfBillable(feedback.shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        this.setState({ shipment: data, message: null })
      }
    })
  }

  /**
   * Gets assigned codes of the shipment given
   */
  getTrackingsOfShipment = () => {
    if (!this.state.shipment) return
    let shipmentcodes = [this.state.shipment.shipmentCode]
    CycleCli.GetAssignedCodes(shipmentcodes).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: response.substring(response.indexOf(' ')) })
      } else {
        let trackings = response.filter(t => t.codeType === 'CODE_TRACKING')
        trackings = trackings.sort(this.sortByDate("assignedTime"))
        let trackingMain = trackings[0]
        let trackingsDispatches = []
        trackings.forEach((t, index) => {
          if (index !== 0) trackingsDispatches.push(t)
        });
        this.setState({ trackingMain: trackingMain, trackingsDispatches: trackingsDispatches })
      }
    })
  }

  /**
   * Gets feedbacks information of the shipment given
   */
  getFeedbacksOfShipment = () => {
    if (!this.state.shipment) return
    InboxCli.GetFeedbackOfShipment(this.state.shipment.shipmentCode, true, true, true, true, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        this.setState({
          message: null,
          shipmentFeedbacks: data
        },
          () => {
            this.getStatesInfo()
            this.getCertsInfo()
            this.getProofsInfo()
            this.getDocuments()
            this.getStampedCopies()
          })
      }
      
    })
  }

  /**
   * Gets states information of shipment to display it in the summary
   */
  getStatesInfo = () => {
    InboxCli.GetStates(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STATE).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        data = data.map(st => {
          let temp = null
          if (st !== null) {
            temp = Object.assign({}, st)
            temp.stateData = JSON.parse(st.stateData)
          }

          if (st.returnId === this.props.feedback.returnId) this.setState({ currentStateData: temp })
          
          return temp
        })
        let filtered = data.filter(d => d !== null && d.stage !== InboxCli.RETURN_STAGE_RETURN)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ states: filtered, message: null })
      }
      
    })
  }

  /**
   * Gets certs information of shipment to display it in the summary
   */
  getCertsInfo = () => {
    InboxCli.GetCerts(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_CERT).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ certs: filtered, message: null })
      }
    })
  }

  /**
   * Gets proofs information of shipment to display
   */
  getProofsInfo = () => {
    InboxCli.GetProofs(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_PROOF).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ proofs: filtered, message: null })
      }
    })
  }

  /**
   * Gets documents information of shipment to display
   */
  getDocuments = () => {
    InboxCli.GetDocuments(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_DOCUMENT).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ documents: filtered, message: null })
      }
    })
  }

  /**
   * Gets stamped copies information of shipment to display
   */
  getStampedCopies = () => {
    InboxCli.GetStampedCopy(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STAMPED_COPY).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ stampedCopies: filtered, message: null })
      }
    })
  }

  /**
   * Download original document of shipment
   */
  downloadDocument = () => {
    if (this.props.role === Roles.ROLE_USER.Name) {
      this.downloadShipmentDocument()
      return
    }

    if (this.props.role === Roles.ROLE_ADMIN.Name || this.props.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadShipmentDocumentOfBillable()
      return
    }
  }

  downloadShipmentDocument = () => {
    if (!this.state.shipment) return
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocument(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')) })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  downloadShipmentDocumentOfBillable = () => {
    if (!this.state.shipment) return
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocumentOfBillable(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')) })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  
  /**
   * Set the state open / collapsed of Collapse elements for expandable rows.
  */
  setOpen = () => {
    this.setState({ open: !this.state.open },
      () => {
        if (this.state.open) {
          this.getFeedbacksOfShipment()
          this.getTrackingsOfShipment()
        }
      })
  }

  /**
   * Checkbox row onChange event. It calls the parent component function to add or remove feedback
   * from feedbacks selected list
   * @param {*} event 
   */
  handleChange = (event) => {
    this.setState({ checked: !this.state.checked }, () => {
      let returnId = event.target.name;
      let option = this.state.checked ? "CHECKED" : "UNCHECKED"

      this.props.addOrRemoveSelectedFeedbacks(returnId, option)
    })
  }

  /**
   * Set the state open of shipment summary dialog.
  */
  handleOpenModal = () => {
    this.setState({ openModal: true })
    this.setState({ isLoadingDraft: false })
  }

  /**
   * Set the state closed of shipment summary dialog.
  */
  handleCloseModal = () => {
    this.setState({ openModal: false })
  }
  
  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountDestinationAddressWho = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let who = this.state.shipment.destinationAddress.who
    return who
  }

  getProductDescription = () => {
    let description = ""
    this.props.products && this.state.shipment && this.state.shipment.features && this.props.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /**
   * download the file associated to feedback
  */
  downloadFeedbackFile = (event) => {
    let name = event.currentTarget.getAttribute('name')
    let returnId = name ? name : this.props.feedback.returnId

    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackFile(returnId).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  /**
    * to close snackbar
   */
  handleonClose = () => {
    this.setState({ message: null, severity: "error" })
  }

  /**
   * sort json by date by atribute asc
   */
  sortByDate(prop) {
    return function (a, b) {
      if (a && b) {
        var a2 = Date.parse(a[prop].substring(0, 23) + a[prop].substring(26));
        var b2 = Date.parse(b[prop].substring(0, 23) + b[prop].substring(26));
        return new Date(a2).getTime() - new Date(b2).getTime()
      }
    }
  }
  
  /**
   * get url to logistic operator
   */
  getUrlOperator = (tracking) => {
    if (!tracking) return ''
    let products = ["PQ", "PK", "NB", "CD", ...ProductCli.SIDI_PRODUCT_CODE];
    let codTracking = tracking.codeValue
    let initTracking = codTracking && codTracking.slice(0, 2);
    const url = products.includes(initTracking) ?
      'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=' + codTracking : ''
    return url
  }

  bytesToBestMagnitude = (len) => {
    let sizes = ["B", "KB", "MB", "GB", "TB"]
    let order = 0;
    while (len >= 1024 && order < sizes.length - 1) {
      order++;
      len = len / 1024;
    }
   
    let newLen = (Math.round(len * 100) / 100).toFixed(1) + " " + sizes[order]
    return newLen
  }

  render() {
    const { feedback } = this.props
    let url = this.getUrlOperator(this.state.trackingMain)

    return (
      <React.Fragment>
        <TableRowStyled className={!feedback.read ? "unread-row" : ""}>
          <TableCellStyled className="text-align-center">
            <Checkbox
              checked={this.state.checked}
              onChange={this.handleChange}
              name={feedback.returnId}
              color="primary"
              icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
              checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
            />
          </TableCellStyled>
         
          <TableCellStyled className="text-align-center" style={feedback.read ? { borderLeft: 'solid 5px #B2B2B2' } : { borderLeft: 'solid 5px #47A6D6' }}>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.open ? localizer.ExpandLess : localizer.ExpandMore}</Typography>}>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>
            {(() => {
              switch (feedback.returnType) {
                case InboxCli.RETURN_STAGE_STATE:
                  return <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InboxStates}</Typography>}><img src={StateIcon} alt="" /></Tooltip>
                case InboxCli.RETURN_STAGE_PROOF:
                  return <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InboxProofs}</Typography>}><img src={ProofIcon} alt="" /></Tooltip>
                case InboxCli.RETURN_STAGE_CERT:
                  return <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InboxCetificates}</Typography>}><img src={CertIcon} alt="" /></Tooltip>
                case 'REPORT':
                  return <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InboxReports}</Typography>}><img src={ReportIcon} alt="" /></Tooltip>
                case InboxCli.RETURN_STAGE_STAMPED_COPY:
                  return <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.InboxStampedCopy}</Typography>}><img src={StampIcon} alt="" /></Tooltip>
                case InboxCli.RETURN_STAGE_DOCUMENT:
                  return <Tooltip title={<Typography className="typography-generic">{localizer.InboxDocuments}</Typography>}><i className="fa-solid fa-file-lines font-size-25"></i></Tooltip>
                default:
                  return <i className="fa-solid fa-file-lines font-size-25"></i>
              }
            })()}
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen} >
            {this.state.shipment && this.state.shipment.features && this.state.shipment.features.reference &&
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.shipment.features.reference}</Typography>}>
                <span>{this.state.shipment.features.reference.length > 20 ? this.state.shipment.features.reference.substring(0, 15) + "..." : this.state.shipment.features.reference}</span>
              </Tooltip>
            }
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.handleOpenModal}>{feedback.shipmentCode}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>
            <Typography className="typography-generic" style={{ wordBreak: "break-all" }}>{this.mountDestinationAddressWho()}</Typography>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>{feedback.description}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>{DateCustom.convertUTCToLocalTime(feedback.recordedTime)}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            
            {(() => {
              return feedback.returnType !== InboxCli.RETURN_STAGE_STATE ?
                <i className="fa-solid fa-circle-down cursor-pointer font-size-20" onClick={this.downloadFeedbackFile}></i>
                :
                ""
            })()}
            
          </TableCellStyled>
        </TableRowStyled>
        {/* Collapse row */}
        <TableRow>
          <TableCellStyled style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              <Grid container direction="row" style={{ borderBottom: "1px solid #DADADA" }}>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxChronology}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  {this.state.shipment &&
                    <Grid container item md={12}>
                      <Grid item md={5}><Typography className="typography-generic small"> {DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid>
                      <Grid item md={7}><Typography className="typography-generic small bigweight">{localizer.InboxDateEmission}</Typography></Grid>
                    </Grid>
                  }
                  {this.state.states && this.state.states.slice(-3).map((state, index) => {
                    let stateCode = StateCodes.CODES.find(c => c.stateCode === state.stateCode)
                    let stateName = stateCode ? stateCode.name : null
                    return (
                      <Grid container item md={12} key={state.returnId}>
                        <Grid item md={5}><Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(state.timestamp)}</Typography></Grid>
                        <Grid item md={7}>
                          <Typography className="typography-generic small bigweight pb-0 pt-0">
                            {stateName}
                          </Typography>
                          <Typography className="typography-generic xsmall  pb-0 pt-0">
                            {state.stateData.Details ? state.stateData.Description + " - " + state.stateData.Details : state.stateData.Description}
                          </Typography>
                        </Grid>
                      </Grid>
                    )
                  }
                  )}
                  {this.state.trackingMain &&
                    <Grid container direction="row" className="mt-15">
                      <Grid item md={12} >
                        <Grid item md={12}>
                          <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: </Typography></Grid>
                      </Grid>
                      <Grid container item md={12} >
                        <Grid item md={5}><Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(this.state.trackingMain.assignedTime)}</Typography></Grid>
                        <Grid item md={7}><Typography className="typography-generic small bigweight"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{this.state.trackingMain.codeValue}</a></Typography></Grid>
                      </Grid>
                    </Grid>
  
                  }
                  {this.state.trackingsDispatches && this.state.trackingsDispatches.length !== 0 &&
                    <Grid container item md={12} className="mt-15">
                      <Grid item md={12}>
                        <Typography className="typography-generic bigweight secondary"> {localizer.ReDispatches}: </Typography>
                        <hr className="hr-custom" />
                      </Grid>
                      {this.state.trackingsDispatches && this.state.trackingsDispatches.map(t => {
                        let url = this.getUrlOperator(t)
                        return (
                          <Grid container item md={12}>
                            <Grid item md={5}><Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(t.assignedTime)}</Typography></Grid>
                            <Grid item md={7}><Typography className="typography-generic small bigweight"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{t.codeValue}</a></Typography></Grid>
                          </Grid>

                        )
                      })
                      }
                      {/* 
                    <Button className="button-generic primary width-auto ml-20 m-10" variant="outlined" startIcon={<LocationOnIcon />}>
                      {localizer.PostalOperator}
                    </Button> */}
                    </Grid>
                  }
                </Grid>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                    <Grid item md={8}><Typography className="typography-generic small">{this.getProductDescription()}</Typography></Grid>
                  </Grid>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxDestination}:</Typography></Grid>
                    <Grid item md={8}>
                      <Typography className="typography-generic small white-space-pre" style={{ overflowX: "auto" }}>{this.mountDestinationAddress()}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={4}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxDocuments}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={9}>
                      <Typography className="typography-generic small textinline bigweight link-hover" onClick={this.downloadDocument}>{localizer.InboxDocumentOriginal}</Typography>
                      <Typography className="typography-generic xsmall m-0 pt-0">{this.state.shipment && DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography>
                    </Grid>
                    <Grid item md={3} className="text-align-right mt-5" >
                      <Chip size="small" className="document-tag" icon={<i className="fa-solid fa-file-lines font-size-15 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                    </Grid>
                  </Grid>
                  {this.state.documents && this.state.documents.map((document) => {
                    
                    let size = document !== null ? this.bytesToBestMagnitude(document.documentSize) : 0
                    return (
                      <Grid container item md={12} key={document.returnId}>
                        <Grid item md={9}>
                          <Typography name={document.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{document.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(document.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip size="small" className="document-tag" icon={<i className="fa-solid fa-file-lines font-size-15 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} name={document.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.stampedCopies && this.state.stampedCopies.map((stampedCopy) => {

                    let size = stampedCopy !== null ? this.bytesToBestMagnitude(stampedCopy.documentSize) : 0
                    return (
                      <Grid container item md={12} key={stampedCopy.returnId}>
                        <Grid item md={9}>
                          <Typography name={stampedCopy.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{stampedCopy.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(stampedCopy.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>

                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip size="small" className="document-tag" icon={<i className="fa-solid fa-stamp font-size-15 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxStampedCopy}</Typography>} name={stampedCopy.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.proofs && this.state.proofs.map((proof) => {
                    let size = proof !== null ? this.bytesToBestMagnitude(proof.documentSize) : 0
                    return (
                      <Grid container item md={12} key={proof.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={proof.returnId} onClick={this.downloadFeedbackFile}>{proof.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(proof.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip size="small" className="proof-tag" icon={<i className="fa-solid fa-file-lines font-size-15 color-proof-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxProof}</Typography>} name={proof.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.certs && this.state.certs.map((cert, index) => {
                    let size = cert !== null ? this.bytesToBestMagnitude(cert.documentSize) : 0
                    return (
                      <Grid container item md={12} key={cert.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={cert.returnId} onClick={this.downloadFeedbackFile}>{cert.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(cert.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip size="small" className="cert-tag" icon={<i className="fa-solid fa-certificate font-size-15 color-cert-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxCert}</Typography>} name={cert.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ padding: "5px" }}>
                <Grid item md={11} style={{ maxHeight: 50 }}></Grid>
                <Grid item md={1} style={{ maxHeight: 50 }}>
                  <Button className="button-generic card font-size-12" variant="outlined" size="small" onClick={this.handleOpenModal}>{localizer.InboxViewAll}</Button>
                </Grid>

              </Grid>
            </Collapse>
          </TableCellStyled>
        </TableRow>
        {this.state.openModal &&
          <FeedbackShipmentSummary key={feedback.returnId} shipmentCode={feedback.shipmentCode} openModal={this.state.openModal} handleCloseModal={this.handleCloseModal} handleisLoadingDraft={this.handleisLoadingDraft} trackingMain={this.state.trackingMain} trackingsDispatches={this.state.trackingsDispatches}></FeedbackShipmentSummary>
        }
        {/* Waiting for service response. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
        {/* Check all as read success confirmation. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/inbox/sections/FeedbackRow.js